// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Import your components/pages

import Login from "./Components/Login/Login";
import Products from "./Components/Pages/Admin/Products/Products";
import Productdetails from "./Components/Pages/Admin/Products/Addproducts/AddProduct";
import Editproduct from "./Components/Pages/Admin/Products/Editproduct/Editproduct";
import StockIn from "./Components/Pages/Admin/Products/Stock/StockIn";
import StockOut from "./Components/Pages/Admin/Products/Stock/StockOut";
import StockHistory from "./Components/Pages/Admin/Products/Stock/StockHistory";




function App() {
  return (
  
    <Router>
      {/* Navbar always visible */}
    

      {/* Routes */}
      <Routes>
        {/* <Route path="/" element={<Navbar />} /> */}
        <Route path="/" element={<Login />} />
          <Route path="/products" element={<Products />} />
        <Route path="/productdetail" element={<Productdetails />} />
<Route path="/editproduct/:id" element={<Editproduct />} />  

  <Route path="/stockin/:id" element={<StockIn />} />
                <Route path="/stockout/:id" element={<StockOut />} />
                <Route path="/stockhistory/:id" element={<StockHistory />} />
      </Routes>
    </Router>
   
  );
}

export default App;
